import { InMemoryHeader, InMemoryString } from "pbas-vue-components";
import { i18n } from '@/plugins/i18n';

function getHeaders(languages, systemColors) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "views.downloadcenter.icon",
      type: new InMemoryString("Icon", {
        getHtml: (item, type) => {
          return `<i class="v-icon notranslate mdi theme--light ${
            item.Icon
          }"></i><span style="margin-left:5px">${item.Icon}</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.left_drawer_menu_items.title_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`Title${lang.language.toUpperCase()}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }
  headers.push(
    new InMemoryHeader({
      title: "headers.left_drawer_menu_items.url",
      type: new InMemoryString("Url"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  headers.push(
    new InMemoryHeader({
      title: "globals.color",
      type: new InMemoryString("Color", {
        getHtml: (item, type) => {
          if (item.Color === null || item.Color === undefined) {
            return "";
          }
          const keys = Object.keys(systemColors).filter(
            (o) => o.toLowerCase() === item.Color.toLowerCase()
          );
          if (keys.length > 0) {
            const index = keys[0];
            return `<div style="background-color:${
              systemColors[index]
            };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
              item.Color
            }</span>`;
          }
          return `<div style="background-color:${
            item.Color
          };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
            item.Color
          }</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  headers.push(
    new InMemoryHeader({
      title: "headers.left_drawer_menu_items.popup",
      type: new InMemoryString("Popup", {
        getString: (item) => {
          if (item.Popup === undefined || item.Popup === null) {
            return "";
          }
          return i18n.t("enums." + item.Popup);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  headers.push(
    new InMemoryHeader({
      title: "headers.left_drawer_menu_items.page_title_color",
      type: new InMemoryString("PageTitleColor", {
        getHtml: (item, type) => {
          if (
            item.PageTitleColor === null ||
            item.PageTitleColor === undefined
          ) {
            return "";
          }
          const keys = Object.keys(systemColors).filter(
            (o) => o.toLowerCase() === item.PageTitleColor.toLowerCase()
          );
          if (keys.length > 0) {
            const index = keys[0];
            return `<div style="background-color:${
              systemColors[index]
            };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
              item.PageTitleColor
            }</span>`;
          }
          return `<div style="background-color:${
            item.PageTitleColor
          };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
            item.PageTitleColor
          }</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  headers.push(
    new InMemoryHeader({
      title: "headers.dashboard_items.show_to_roles",
      type: new InMemoryString("ShowTo", {
        getString: (item) => {
          if (
            item.ShowTo === null ||
            item.ShowTo === undefined ||
            !Array.isArray(item.ShowTo) ||
            item.ShowTo.length === 0
          ) {
            return "All";
          }
          return item.ShowTo.join(", ");
        },
        getHtml: (item, type) => {
          if (
            item.ShowTo === null ||
            item.ShowTo === undefined ||
            !Array.isArray(item.ShowTo) ||
            item.ShowTo.length === 0
          ) {
            return "All";
          }
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.left_drawer_menu_items.keywords_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`Keywords${lang.language.toUpperCase()}`, {
          getString: (item) => {
            if (!item) return "";
            if (!item.Keywords) return "";
            return item[`Keywords${lang.language.toUpperCase()}`];
          },
          getHtml: (item, type) => {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              type.getString(item, type) +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }
  headers.push(
    new InMemoryHeader({
      title: "components.portal.sub_menus",
      type: new InMemoryString("SubMenus", {
        getString: (item) => {
          if (!item) return "";
          if (!item.SubMenus) return "";
          return item.SubMenus.map((o) => {
            let str = "(";
            for (const lang of languages) {
              str += `${lang.language}: ${
                o["Title" + lang.language.toUpperCase()]
              } `;
            }
            str += `url: ${o.Url})`;
            return str;
          }).join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      sortable: true,
      version: 1,
    })
  );
  return headers;
}
export default getHeaders;
